module.exports = __webpack_public_path__ + "static/media/peda_blink.c8dc8e8f.gif";